export default defineNuxtPlugin((nuxtApp) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  nuxtApp.provide('timezone', timezone);
});